import { Link, useLoaderData } from "react-router-dom";

import { hotlist } from "../constants/hotlist";
import { generateImageURL } from "../utils/convertCyrToLat";

function Hotlist() {
  const hotlistName = "Горещи летни оферти";
  document.title = "FORD - " + hotlistName;

  const cars = useLoaderData().sort((a, b) => a.new_price - b.new_price);

  return (
    <div>
      <div className="container grid grid-cols-1 gap-4 px-4 md:grid-cols-2 lg:grid-cols-4">
        {cars.map((car) => {
          if (hotlist.includes(car.id)) {
            const imageURL = generateImageURL(car);

            let discount =
              ((car.old_price - car.new_price) / car.old_price) * 100;

            return (
              <div
                layout
                className="p-2 mt-4 shadow-md item hover:shadow-lg"
                key={car.id}
                id="the-list"
              >
                <div className="flex items-start justify-between">
                  <div className="min-h-[92px]">
                    <h3 className="mt-2 text-2xl uppercase text-fordBlue">
                      {car.model}
                    </h3>
                    <p className="text-sm text-gray-500">Оферта {car.id}</p>
                  </div>
                  {discount !== 0 && (
                    <div className="flex flex-col px-4 py-2  text-center rounded-sm bg-fordRed min-w-[180px]">
                      <p className="text-sm tracking-widest text-white uppercase">
                        Ексклузивна оферта
                      </p>
                      <p className="text-sm tracking-widest text-center text-white uppercase ">
                        -
                        {new Intl.NumberFormat("bg", {
                          maximumFractionDigits: 0,
                        }).format(discount)}
                        %
                      </p>
                    </div>
                  )}
                </div>
                <img src={imageURL} alt="" />
                <div className="flex justify-between">
                  <p className="text-gray-500">Гориво</p>
                  <p className="text-fordBlue">{car.fuel}</p>
                </div>
                <div className="flex justify-between">
                  <p className="text-gray-500">Скоростна кутия</p>
                  <p className="text-fordBlue">{car.gearbox}</p>
                </div>
                <p className="p-4 mt-4 text-xl text-center bg-gray-50">
                  Цена:{" "}
                  {new Intl.NumberFormat("bg", {
                    minimumFractionDigits: 0,
                  }).format(car.new_price)}{" "}
                  <span className="text-sm">лв. с ДДС</span>
                </p>
                <div className="mx-auto text-center">
                  <Link to={`/${car.id}`}>
                    <button className="mt-4 mb-2 border btn-primary border-fordBlue hover:bg-white hover:text-fordBlue">
                      Виж още
                    </button>
                  </Link>
                </div>
              </div>
            );
          } else {
            return null;
          }
        })}
      </div>
    </div>
  );
}

export default Hotlist;
